import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";



export const companyJobFunctionsApi = createApi({
  reducerPath: "companyJobFunctionsApi ",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: ["CompanyJobFunctions"],
  endpoints: builder => ({
    /**
     * @Services - Company Job Functions
     */
    fetchAllCompanyJobFunctions: builder.query({
      query: ({ companyId }) => ({
        url: `/company/${companyId}/company-job-functions/all`,
        method: "GET",
      }),
      providesTags: ["CompanyJobFunctions"],
    }),
  }),
});

export const {
  useFetchAllCompanyJobFunctionsQuery,

} = companyJobFunctionsApi;
